import { render, staticRenderFns } from "./external-tracker.vue?vue&type=template&id=207c3f64"
import script from "./external-tracker.vue?vue&type=script&lang=js"
export * from "./external-tracker.vue?vue&type=script&lang=js"
import style0 from "./external-tracker.vue?vue&type=style&index=0&id=207c3f64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports